import React from 'react';
import Page from '../../components/ui/Page';
import AuthenticationForm, { StateInterface } from '../../components/application/Authentication/Form';
import Onboarding from '../../components/application/Authentication/Onboarding';
import * as Styles from './AuthenticationStyles';

interface Location {
  state?: StateInterface;
}

interface Props {
  readonly location: Location;
}

const Authentication: React.FC<Props> = ({ location }: Props) => {
  const previousState = location.state || {
    from: {
      pathname: '',
    },
  };

  return (
    <Page>
      <Styles.Container>
        <Styles.FormContainer>
          <AuthenticationForm previousState={previousState} />
        </Styles.FormContainer>
        <Onboarding />
      </Styles.Container>
    </Page>
  );
};

export default Authentication;
